module.exports = __webpack_public_path__ + "img/speedometerArrow.8d3bd5ac.svg";